




































import {Component, Watch, Vue, Prop} from "vue-property-decorator";
import {faUpload} from "@fortawesome/free-solid-svg-icons";
import {UserFile, UserFileRequest, UserFileService} from "@/services/userFile.service";

@Component({name: "ImageUploader"})
export default class ImageUploader extends Vue {

    @Prop()
    public value!: UserFile;

    private uploadIcon = faUpload;
    private error: string | null = null;

    private request!: UserFileRequest;

    private service!: UserFileService;

    private file: any | null = null;

    private imagePreview: string | null = null;

    private mounted() {
        this.service = new UserFileService();

        if (this.value) {
            this.request = {
                name: this.value.name,
                alt: this.value.alt,
                file: null,
            }

            this.imagePreview = this.value.cdn;
        }
    }

    private clearRequest() {
        this.request = {
            name: "",
            alt: "",
            file: null,
        }
        this.imagePreview = null;
    }

    private async fileUpload(e: any) {
        this.error = null;
        if (e.target.files.length === 0) {
            this.file = null;
        }

        this.file = e.target.files[0];
        this.imagePreview = URL.createObjectURL(this.file);
        this.clearRequest();
        this.request.name = this.file.name;
    }

    private async save() {

        const data = new FormData();
        data.append('name', this.request.name);
        data.append('alt', this.request.alt);
        data.append('file', this.file);

        const res = await this.service.postFormData(data);

        if (res.success) {
            this.$emit("input", res.result);
            this.clearRequest(); 
            this.$forceUpdate();
        }
    }
}
